import Http from './request';
//登录
export const login = (data) => {
    return Http({
        url: '/user/userLogin',
        method: 'post',
        data
    })
}

/**
 * 获取全局配置
 **/
export const getGlobalConfig = (params = {}) => {
    return Http({
        url: '/common/getConfig',
        method: 'get',
        params
    })
}

/**
 * 获取全局配置
 **/
export const getCompanyName = (params = {}) => {
    return Http({
        url: '/screen/getCompanyName',
        method: 'get',
        params
    })
}

/**
 * 注册
 **/
export const registerPcUser = (data = {}) => {
    return Http({
        url: '/screen/registerPcUser',
        method: 'post',
        data
    })
}
